import type {DecoratedExportFormat} from '../../types'

export interface PartialComponentExport {
    structure: Pick<DecoratedExportFormat, 'rootComponent' | 'components'>
    other: Pick<DecoratedExportFormat, 'components' | 'dependencies' | 'globalData' | 'fixerVersions'>
    style: Pick<DecoratedExportFormat, 'components' | 'variantsMap'>
    version: DecoratedExportFormat['version']
}

export const TAB_WIDTH = 2

export const STRUCTURE_COMPONENT_PROPERTIES_KEYS = new Set(['components'])
